import CreateCategory from "../../../Components/Admin/CreateCategory";

const CreateCategoryPage = () => {
  return <CreateCategory isEdit={false} />;
};

export default CreateCategoryPage;
